import { produce } from 'immer';
import PETS_PHOTOS_CONSTANTS from 'src/modules/photos/constants/pets-photos';

const initialState = {
  status: 'LOADING',
  isLoaded: false,
  isMore: true,
  page: 0,
  data: [],
  error: null,
  meta: {
    offset: 0,
    limit: 8,
    total: 0,
    prevLink: null,
    nextLink: null,
  },
};

const petsPhotosReducer = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_DATA:
      draft.data = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_STATUS:
      draft.status = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_IS_LOADED:
      draft.isLoaded = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_PAGE:
      draft.page = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_ERROR:
      draft.error = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_IS_MORE:
      draft.isMore = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.SET_PETS_PHOTOS_META:
      draft.meta = action.payload;
      break;
    case PETS_PHOTOS_CONSTANTS.RESET_PETS_PHOTOS:
      return initialState;
    default:
      return state;
  }
});

export default petsPhotosReducer;
